import { Button, Drawer } from "@arco-design/web-react";

import type { ResourcePointSkuItem, ResourcePointSpuItem } from "../types";
import { ResourcePointSkuTable } from "./ResourcePointSkuTable";

type ResourcePointSkuManagementDrawerProps = {
  spu: ResourcePointSpuItem | null;
  canManage: boolean;
  canDelete: boolean;
  inactive: boolean;
  onClose: () => void;
  onAfterClose: () => void;
  onCreate: (spu: ResourcePointSpuItem) => void;
  onEdit: (spu: ResourcePointSpuItem, sku: ResourcePointSkuItem) => void;
  onDelete: (spu: ResourcePointSpuItem, sku: ResourcePointSkuItem) => void;
  onToggleDisabled: (spu: ResourcePointSpuItem, sku: ResourcePointSkuItem) => void;
  togglePendingSkuIds: ReadonlySet<string>;
  errorMessage: string;
};

/** 承载指定考察点 SKU 列表及其管理入口。 */
export function ResourcePointSkuManagementDrawer(
  props: ResourcePointSkuManagementDrawerProps,
) {
  const { spu } = props;

  return (
    <Drawer
      {...({
        role: "dialog",
        "aria-label": spu ? `${spu.pointName} · SKU 管理` : "SKU 管理",
        "aria-modal": props.inactive ? "false" : "true",
        ...(props.inactive ? { "aria-hidden": "true" } : {}),
      } as Record<string, string>)}
      className="resource-point-sku-management-drawer"
      title={spu ? `${spu.pointName} · SKU 管理` : "SKU 管理"}
      visible={Boolean(spu)}
      placement="right"
      width="60%"
      footer={<Button onClick={props.onClose}>关闭</Button>}
      autoFocus
      focusLock
      unmountOnExit
      onCancel={props.onClose}
      afterClose={props.onAfterClose}
    >
      {spu ? (
        <ResourcePointSkuTable
          spu={spu}
          canManage={props.canManage}
          canDelete={props.canDelete}
          onCreate={props.onCreate}
          onEdit={props.onEdit}
          onDelete={props.onDelete}
          onToggleDisabled={props.onToggleDisabled}
          togglePendingSkuIds={props.togglePendingSkuIds}
          errorMessage={props.errorMessage}
        />
      ) : null}
    </Drawer>
  );
}
